import React, { useState, useEffect, useRef, useContext } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleUser, faGear, faLightEmergency, faTag } from "@fortawesome/pro-duotone-svg-icons";
import { faStar } from '@fortawesome/free-solid-svg-icons';
import HomeIcon from '@material-ui/icons/Home';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { withNamespaces } from 'react-i18next';
import { getMenuConfig } from '../../utils/menuNavigationHelper';
import { isSmallerThanScreenX, isIOS } from '../../utils';
import * as storage from '../../utils/storage';
import { IsEnglish } from '../../utils/language';
import { IsEmployeeMode } from '@users';
import * as keyMenu from '../../scripts/KeyMenu';
import i18next from 'i18next';
import * as TypeHelpOnline from '../../scripts/TypeHelpOnline'
import AccessMode from '@components/menu/AccessMode';
import LoadingLayer from '@controls/LoadingLayer';
import { IsSupervisorMode } from '@users';
import ReportViewer from '@shared/reportViewer/ReportViewer';
import AlertAlgo from '@controls/AlertSnack';
import { reportTypes } from '@utils/reportHelper';
import { messagesTypes } from '@utils/constants';
import { manageFavoritesMenus, listFavouritesMenus } from '@actions/configMenu';
import { manageSupervisorFavoritesMenus, listSupervisorFavouritesMenus } from '@actionsSup/configMenu';
import styles from '@styles/chat.module.css';
import { ChatContext } from '@/ChatProvider';
import { MessageContext } from '@/MessageProvider';
import { FavouritesMenusContext } from '@/FavouritesMenusProvider';
import { favMenuActionTypes } from '@utils/constants';

const useStyles = makeStyles(theme => ({
    divNavigationReset: {
        position: 'absolute',
        bottom: 0, left: 0,
        right: 0,
        top: '1000px',
        textAlign: '-webkit-center',
        transition: 'top 0.3s ease 0.3s',
        backgroundColor: '#f5f5f5',
        zIndex: 9998,
    },
    divNavigation: {
        position: 'absolute',
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        textAlign: '-webkit-center',
        transition: 'top 0.3s ease 0.3s',
        backgroundColor: '#f5f5f5',
        zIndex: 11001
    },
    divAvatar: {
        backgroundColor: '#f5f5f5',
        marginRight: 'auto',
        float: 'left',
        width: 'calc(100% - 30px)',
        margin: '15px',
        marginBottom: '10px'
    },
    divIcon: {
        textAlign: 'left',
        color: 'var(--color1)',
        float: 'left',
        marginTop: '5px',
        '& > svg': {
            width: '50px',
            height: '50px'
        }
    },
    divUser: {
        float: 'left',
        display: 'table',
        color: 'var(--color4)',
        marginLeft: '5px',
        marginTop: '6px',
        '& > span': {
            display: 'table',
            width: '200px',
            textAlign: 'left'
        }
    },
    spanUserCode: {
        fontSize: '12px',
        fontWeight: 'bold'
    },
    spanUserName: {
        fontWeight: 'bold'
    },
    divSettings: {
        float: 'right',
        margin: '4px'
    },
    divRootButtons: {
        display: 'table',
        width: 'calc(100% - 20px)',
    },
    divButton: {
        display: 'table',
        borderRadius: '8px',
        backgroundColor: 'var(--color2)',
        padding: '15px 15px 12px 15px',
        boxShadow: '0px 0px 4px 1px #c2c2c27a',
        float: 'left',
        width: 'calc(50% - 14px)',
        margin: '7px',
        cursor: 'pointer',
        position: 'relative',
        color: '#818181',
        fontWeight: 'bold',
        fontSize: '15px',
        border: '1px solid #c7c7c7a8',
        textAlign: 'center'
    },
    faStarIcon: {
        position: 'absolute',
        top: '10px',
        right: '10px',
    },
    menuIcon: {
        width: 'fit-content',
        margin: 'auto',
    },
    divClose: {
        float: 'right',
    },
    divCloseIOS: {
        float: 'right'
    },
    divLabelMenu: {
        display: 'table',
        textAlign: 'left',
        marginLeft: '15px',
        fontWeight: 'bold',
        fontVariant: 'all-small-caps',
        fontSize: '22px',
        float: 'left'
    },
    divSeparator: {
        display: 'table',
        width: 'calc(100% - 20px)',
        '& > hr': {
            backgroundColor: '#adadad',
            marginTop: '5px',
            height: '2px',
            borderRadius: '20px',
            marginBottom: '10px'
        }
    },
    divAlignButtons: {
        width: '100%',
        overflow: 'auto'
    },
    divScrollSign: {
        backgroundColor: '#c0c0c0',
        borderRadius: '12px',
        width: '26%',
        height: '5px',
        marginTop: '15px'
    },
    divScrollSignIOS: {
        backgroundColor: '#c0c0c0',
        borderRadius: '12px',
        width: '26%',
        height: '5px',
        marginTop: '5px',
    },
    divVersion: {
        display: 'inline-block',
        fontSize: '13px',
        backgroundColor: '#8080804f',
        borderRadius: '20px',
        padding: '2px 8px',
        color: '#808080'
    },
    firstRow: {
        display: 'flex',
        width: '100%',
        alignItems: 'center',
        height: '40px'
    },
    middleDiv: {
        flexGrow: '1',
        alignContent: 'center',
        textAlign: 'right'
    }
}));

function MenuNavigation(props) {
    const classes = useStyles();
    const { dispatch } = useContext(MessageContext);
    const { state } = useContext(ChatContext);
    const { favMenuState, favMenuDispatch } = useContext(FavouritesMenusContext);
    const [Css, setCss] = useState(classes.divNavigationReset);
    const [menus, setMenus] = useState([]);
    const [openConfirm, setOpenConfirm] = useState(false);
    const [userCode, setUserCode] = useState(storage.getUserCode());
    const [userName, setUserName] = useState(storage.getUserName());
    const [useAbbreviation, setUseAbbreviation] = useState(false);
    const [isProcessing, setIsProcessing] = React.useState(false);
    const [openReport, setOpenReport] = useState(false);
    const [reportType, setReportType] = useState(reportTypes.FlAG);
    const [reportParameters, setReportParameters] = useState(null);
    const [showMenu, setShowMenu] = useState(true);
    const [version, setVersion] = useState('');
    const [buildNumber, setBuildNumber] = useState(0);
    const isiOS = isIOS();
    const alertRef = useRef(null);

    useEffect(() => {
        loadFavouritesMenus();
        loadMenu();
        resizeMenu();
        setUseAbbreviation(isSmallerThanScreenX(500));
        getVersion();
    }, []);

    useEffect(() => {
        if (props.showAllMenu) {
            // setTimeout just to fix the animation
            setTimeout(() => { setCss(classes.divNavigation) }, 0);
        }
    }, [props.showAllMenu]);

    useEffect(() => {
        // This is to close the menu (all) when we select the menu from de favotire's menu
        if (props.closeAllMenu) {
            setCss(classes.divNavigationReset);
        }
    }, [props.closeAllMenu]);

    const getVersion = () => {
        fetch("./meta.json?v=" + new Date().getMilliseconds())
            .then(response => {
                return response.json();
            })
            .then(meta => {
                const ver = meta.version;
                const build = meta.build ?? 0;
                setVersion(ver);
                setBuildNumber(build);
            });
    }

    const resizeMenu = () => {
        setTimeout(() => {
            const heightWindow = window.innerHeight;
            const menu = document.querySelector('#menuFavorite').clientHeight;
            const offSet = 210;
            const customHeight = heightWindow - menu - offSet;
            const customNavigationHeight = heightWindow - menu;

            const element = document.querySelector("#divMenu");
            if (element !== undefined && element !== null) {
                element.style.height = `${customHeight}px`;
            }

            const elementNavigation = document.querySelector("#divNavigation");
            if (elementNavigation !== undefined && elementNavigation !== null) {
                elementNavigation.style.height = `${customNavigationHeight}px`;
            }

            const elementDivScroll = document.querySelector("#divScrollSign");
            elementDivScroll.style.display = "none";

            if (element.scrollHeight > element.clientHeight) {
                // has scroll
                if (elementDivScroll !== undefined && elementDivScroll !== null) {
                    elementDivScroll.style.display = "block";
                }
            }
        }, 250);
    }

    const showMessageWarning = (message) => {
        alertRef.current.showMessageWarning(message);
    }

    const loadFavouritesMenus = async () => {

        setIsProcessing(true);

        let result;

        if (IsSupervisorMode()) {
            result = await listSupervisorFavouritesMenus();
        } else {
            result = await listFavouritesMenus();
        }

        if (result === undefined) {
            dispatch({ type: messagesTypes.GENERICERROR });
        } else {
            const noRefresh =
                result.length === favMenuState.favouritesMenus?.length &&
                favMenuState.favouritesMenus?.every((value, index) => value === result[index]);

            if (!noRefresh) {
                favMenuDispatch({ type: favMenuActionTypes.SET_FAV_MENU, payload: result });
            }
        }

        setIsProcessing(false);
    }

    const loadMenu = () => {
        let menus = storage.getMenu()?.filter(x => !x.isTab);

        if (!menus) {
            menus = [];
        }

        if (storage.getIsDisplayChatMenu()
            && IsEmployeeMode()) {
            //TODO : static menu CHAT to handle
            menus.push({
                codeMenu: keyMenu.MENU_CHAT,
                descriptionEnglish: "Chat",
                descriptionFrench: "Messagerie",
                isTab: false,
                order: 180
            });
        }

        let menusFormatted = [];

        if (menus) {
            menus.forEach(item => {
                const menuConfig = getMenuConfig(item.codeMenu);
                if (menuConfig.descriptionF && menuConfig.descriptionE) {
                    // Override the database's display text for menu elements
                    item.descriptionFrench = menuConfig.descriptionF;
                    item.descriptionEnglish = menuConfig.descriptionE;
                }
                menusFormatted.push({ item, menuConfig });
            });
            setMenus(menusFormatted);
        }
    }

    const handleCloseMenu = () => {
        setCss(classes.divNavigationReset);
        setTimeout(() => {
            props.handleShowAllMenu(false);
        }, 1000);
    }

    const manageFavorites = async (event, codeMenu) => {
        event.stopPropagation();
        if (favMenuState.favouritesMenus?.length === 4
            && !favMenuState.favouritesMenus.includes(codeMenu)) {
            showMessageWarning(i18next.t('menu:dialog.message'));
            return;
        }

        setIsProcessing(true);

        let result;

        if (IsSupervisorMode()) {
            result = await manageSupervisorFavoritesMenus(codeMenu);
        } else {
            result = await manageFavoritesMenus(codeMenu);
        }

        if (result === undefined) {
            dispatch({ type: messagesTypes.GENERICERROR });
        } else if (result.status === true) {

            let actionType = favMenuActionTypes.ADD_TO_FAV_MENU;

            if (favMenuState.favouritesMenus.filter(x => x === codeMenu).length > 0) {
                actionType = favMenuActionTypes.REMOVE_FROM_FAV_MENU;
            }

            favMenuDispatch({ type: actionType, payload: codeMenu });
        }

        setIsProcessing(false);
    }

    const handleLoadPage = (id) => {
        localStorage.setItem('knkmob.selectedMenu', id);
        props.handleSelectedPage(id)
        setCss(classes.divNavigationReset);
        setTimeout(() => {
            props.handleShowAllMenu(false);
        }, 1500);
    }

    const handleLegalInformation = (typeInfo) => {
        props.handleLegalInfo(typeInfo);
    }

    const handleClose = () => {
        setOpenReport(false);
        setCss(classes.divNavigation);
    }

    const handleClick = () => {
        if (IsSupervisorMode()) {
            setReportType(reportTypes.LIST_EMPLOYEES_PRESENT);
            setReportParameters({});
            setOpenReport(true);
        }
        setTimeout(() => { setCss('') }, 100);
    }

    const handleCloseConfirm = (closeDetail = true) => {
        setOpenConfirm(false);
    }

    const cssDivClose = isiOS ? classes.divCloseIOS : classes.divClose;

    const cssDivScrollSign = isiOS ? classes.divScrollSignIOS : classes.divScrollSign;

    return (
        <div id="divNavigation" className={Css}>
            <LoadingLayer isActive={isProcessing}>

                <div className={classes.divAvatar}>
                    <div className={classes.divIcon}>
                        <FontAwesomeIcon icon={faCircleUser} style={{ color: 'var(--color1)' }} />
                    </div>
                    <div className={classes.divUser}>
                        <span className={classes.spanUserCode}>
                            {userCode}
                        </span>
                        <span className={classes.spanUserName}>
                            {userName}
                        </span>
                    </div>
                    <div className={classes.divSettings}>
                        {IsSupervisorMode() && <IconButton style={{ color: 'var(--color1)' }} aria-label={i18next.t('menu:settings')} component="span" onClick={handleClick}>
                            <FontAwesomeIcon icon={faLightEmergency} style={{ color: '#db5d5d', fontSize: "28px" }} />
                        </IconButton>}
                        <IconButton style={{ color: 'var(--color1)' }} aria-label={i18next.t('menu:settings')} component="span" onClick={() => handleLoadPage(keyMenu.MENU_SETTINGS)}>
                            <FontAwesomeIcon icon={faGear} style={{ color: 'var(--color1)' }} />
                        </IconButton>
                    </div>
                </div>

                <AccessMode setIsProcessing={setIsProcessing} setShowMenu={setShowMenu} />

                <div className={classes.divRootButtons}>
                    {showMenu &&
                        <div>
                            <div className={classes.divSeparator}>
                                <hr />
                            </div>

                            <div className={classes.firstRow}>
                                <div className={classes.divLabelMenu}>Menus</div>

                                <div className={classes.middleDiv}>
                                    <div className={classes.divVersion}>
                                        <FontAwesomeIcon icon={faTag} style={{ marginRight: '3px' }} />
                                        {version}{buildNumber > 0 ? ` (${buildNumber})` : ""}
                                    </div>
                                </div>

                                <div className={cssDivClose}>
                                    <IconButton aria-label="Fermer menu" component="span" onClick={handleCloseMenu}>
                                        <CloseIcon />
                                    </IconButton>
                                </div>
                            </div>
                            <div id="divMenu" className={classes.divAlignButtons}>
                                <div className={classes.divButton} onClick={() => handleLoadPage(keyMenu.MENU_HOME)}>
                                    <FontAwesomeIcon icon={faStar} className={classes.faStarIcon} onClick={(event) => manageFavorites(event, keyMenu.MENU_HOME)} style={{ color: favMenuState.favouritesMenus?.includes(keyMenu.MENU_HOME) ? 'gold' : '' }} />
                                    <div className={classes.menuIcon}>
                                        <HomeIcon style={{ color: '#528d80' }} />
                                    </div>
                                    <span>{i18next.t('menu:home')}</span>
                                </div>
                                {menus && menus.map((obj, index) =>
                                    <div key={index} className={classes.divButton} onClick={() => handleLoadPage(`${obj.menuConfig.id}`)}>
                                        <FontAwesomeIcon icon={faStar} className={classes.faStarIcon} onClick={(event) => manageFavorites(event, obj.item.codeMenu)} style={{ color: favMenuState.favouritesMenus?.includes(obj.item.codeMenu) ? 'gold' : '' }} />
                                        <div className={classes.menuIcon} >
                                            {obj.menuConfig.icon}
                                        </div>
                                        {state.counter > 0 && obj.menuConfig.id === keyMenu.MENU_CHAT && <span className={styles.notificationBadge}>{state.counter}</span>}
                                        <span>{IsEnglish() ? (useAbbreviation && obj.menuConfig.descriptionAbbrE !== '' ? obj.menuConfig.descriptionAbbrE : obj.item.descriptionEnglish)
                                            : (useAbbreviation && obj.menuConfig.descriptionAbbrF !== '' ? obj.menuConfig.descriptionAbbrF : obj.item.descriptionFrench)}</span>
                                    </div>
                                )}
                            </div>
                            <div id="divScrollSign" className={cssDivScrollSign}>
                                &nbsp;
                            </div>
                            <div className="divRootTerms">
                                {storage.getLegalInfo() !== null && storage.getLegalInfo().length > 0 && <div style={{ float: 'left' }}><a className="legalInformation" onClick={() => handleLegalInformation(TypeHelpOnline.Legal_Information)}>{i18next.t('menu:privacyPolicy')}</a></div>}
                                {storage.getTermsUse() !== null && storage.getTermsUse().length > 0 && <div style={{ float: 'left', marginLeft: '15px' }}><a className="legalInformation" onClick={() => handleLegalInformation(TypeHelpOnline.TermsUse_Information)}>{i18next.t('menu:termsUse')}</a></div>}
                            </div>

                            <div className="divReport">
                                {IsSupervisorMode() && reportType != -1 && reportParameters != null && <ReportViewer
                                    open={openReport}
                                    reportType={reportType}
                                    reportParameters={reportParameters}
                                    onClose={handleClose}
                                />}

                                <AlertAlgo ref={alertRef} />

                                <Dialog
                                    style={{ zIndex: 999999 }}
                                    open={openConfirm}
                                    onClose={handleCloseConfirm}
                                    aria-labelledby="draggable-dialog-title"
                                >
                                    <DialogTitle id="draggable-dialog-title">
                                        {i18next.t('menu:dialog.attention')}
                                    </DialogTitle>
                                    <DialogContent>
                                        <DialogContentText>
                                            {i18next.t('menu:dialog.message')}
                                        </DialogContentText>
                                    </DialogContent>
                                    <DialogActions>
                                        <Button onClick={handleCloseConfirm} color="primary" className={styles.defaultButton} variant="contained">
                                            {i18next.t('buttons:close')}
                                        </Button>
                                    </DialogActions>
                                </Dialog>
                            </div>
                        </div>
                    }
                </div>


            </LoadingLayer >
        </div >
    );
}

export default withNamespaces(['login', 'menu', 'report'], { wait: true })(MenuNavigation);